import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import css from "./TitleCoverImage.module.css";
export var TitleCoverImage = function (_a) {
    var coverUrl = _a.coverUrl, titleName = _a.titleName;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(false), failed = _b[0], setFailed = _b[1];
    if (!coverUrl || failed) {
        return (React.createElement("div", { className: css.empty, "data-testid": "title-cover-empty" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.title.detail.cover.empty" })));
    }
    return (React.createElement("img", { className: css.cover, src: coverUrl, alt: formatMessage({ id: "ui-br-agency.title.detail.cover.alt" }, { name: titleName }), loading: "lazy", onError: function () { return setFailed(true); } }));
};
